export default __webpack_public_path__ + "static/media/del.afb17054.png";